import * as React from 'react'
require('../base.module.scss')
import * as cn from 'classnames'
import { LinkProps } from '../Link/Link'
import { Link } from '../Link/Link'
import { BaseComponentProps, extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import * as st from './DropList.module.scss'

// Converting from base 10 to base 36 (https://en.wikipedia.org/wiki/Base36)
const baseRadix = 36

const getLabelProp = (prop: string, custom: any, highlightedLink: any, items: any) => (
    custom ? custom : highlightedLink ? highlightedLink[prop] : items ? items[prop] : prop === 'text' ? '' : (null)
)

export interface DropListProps extends BaseComponentProps {
    links?: LinkProps[]
    isCustomTrigger?: boolean
    customDropListID?: string
    customText?: string
    useNavOffset?: boolean
    customTextChildren?: any
    children?: any
    right?: boolean
}

export const DropList: React.ComponentType<DropListProps> = (props: DropListProps) => {
    const {
        links,
        isCustomTrigger,
        customText,
        customTextChildren,
        customDropListID,
        useNavOffset,
        children
    } = props

    const dropListID =
        customDropListID ||
        Math.random()
            .toString(baseRadix)
            .slice(2)

    const className = extractClassNamesFromProps(props, st.droplist, {
        [st.custom]: isCustomTrigger,
        [st.right]: props.right,
        [st['use-nav-offset']]: Boolean(useNavOffset),
    })

    const labelClassName = cn(st.label, {
        [st.trigger]: !isCustomTrigger,
    })

    const highlightedLink = (links || children as any).find((item: any) => (
        links ? Boolean(item.isHighlighted || item.rel) : Boolean(item.props.isHighlighted || item.props.rel)
    ))

    const labelText = getLabelProp('text', customText, links ? highlightedLink : highlightedLink.props, links ? links[0] : children[0].props)
    const labelChildren = getLabelProp('children', customTextChildren, links ? highlightedLink : highlightedLink.props, links ? links[0] : children[0].props)

    const listItems = (links || children as any).map((child: any, i: number) => (
        <li key={`${i}-${child.text || ''}`}>
          {links ? <Link {...child} /> : child}
        </li>
    ))

    return (
        <div className={className}>
            <input
                type="checkbox"
                id={`av-droplist-${dropListID}`}
                className={st.switch}
            />
            <label
                htmlFor={`av-droplist-${dropListID}`}
                className={labelClassName}
                aria-hidden="true"
            >
                {labelText}{labelChildren}
            </label>
            <ul>{listItems}</ul>
        </div>
    )
}

// Add displayName to preserve the component name on snapshot testing
DropList.displayName = 'DropList'
